import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Row, Alert, Col } from 'react-bootstrap';
import FormBusca from './form_busca';
import PartidoService from '../../../services/partido'
import Partido from './partido';

const ListarPartido = () => {


    const [partido, setPartido] = useState([]);
    const [vazio, setVazio] = useState(false);

    async function fetchPartidoIn() {
        const response = await PartidoService.listar();
        if (response.data.length >= 1) {
            setPartido(response.data)
            setVazio(false)
        } else {
            setPartido([])
            setVazio(true)
        }
    }

    useEffect(() => {
        fetchPartidoIn();
    }, []);


    return (
        <Fragment>
            <Fragment>
                <Col xs={12}>
                    <div className="filtra_lic">
                        <div className="titulo-home">Notificação Liberação Recursos – Lei 9.452/1997</div>
                        <div className="conteudo-lic">
                            A PREFEITA DO MUNICÍPIO DE MACUCO, Estado do Rio de Janeiro, no uso de suas atribuições legais, CONSIDERANDO o que consta no Art. 2º da Lei nº 9.452/1997, DECRETA:
                            <br /><br />
                            <h4>DECRETO Nº1471, DE 18 DE SETEMBRO DE 2023.</h4>
                            <br /><br />
                            Art. 1º - Fica determinado que a Administração Pública Municipal Direta e Indireta, ao receber verbas federais a qualquer título, entendidas como recursos financeiros oriundos de órgãos e entidades da administração federal direta, suas autarquias, fundações públicas, empresas públicas e sociedades de economia mista federais, deverá notificar os partidos políticos, os sindicatos de trabalhadores e as entidades empresariais, com sede no Município de Macuco-RJ, no prazo de 02 (dois) dias úteis, contados do recebimento dos recursos, conforme disposto no art. 2º da Lei Federal nº 9.452/1997, pelos meios a seguir definidos:
                            <br /><br />
                            I- por meio de publicação no Portal da Transparência do Município, no endereço <a href="https://prefeituramacuco.rj.gov.br/transparencia/partidospoliticos">www.prefeituramacuco.rj.gov.br/transparencia/partidospoliticos</a>;
                            <br /><br />
                            II- pelo Diário Oficial Eletrônico do Município, no endereço: <a href="https://prefeituramacuco.rj.gov.br/transparencia/diario" target="_blank">www.prefeituramacuco.rj.gov.br/transparencia/diario</a>;
                            <br />
                        </div>
                    </div>
                </Col>
            </Fragment>
            <Fragment>
                <FormBusca
                    setPartido={setPartido}
                    setVazio={setVazio}
                    fetchPartidoIn={fetchPartidoIn}
                    recursos={partido}
                />
            </Fragment>

            {vazio ? <Fragment>
                <Alert variant='danger'>Sua busca não gerou nenhum resultado :(</Alert>
            </Fragment> :
                <Fragment>
                    <h3>Arquivos:</h3><br />
                    <Row xs={1}>
                        {partido.map((partid, index) =>
                            <Partido
                                partid={partid}
                                key={index}
                            />
                        )}
                    </Row>
                </Fragment>}
        </Fragment>

    )
}

export default ListarPartido;